<template>
  <sidebar-layout>
    <template #top>
      <status-banner :text="attendingStatusText" :icon="iconClass" :status="bannerStatus" />
    </template>

    <template v-if="attending">
      <rsvped-shifts v-if="shiftedEvent" />
      <not-attending-button v-else />
    </template>

    <change-to-attending v-if="notAttending && !eventStatus.full" />

    <template v-if="!eventStatus.full && eventCanBeShared">
      <hr class="my-4">
      <sharing-prompt :title="i18n.t('events.show.share_with_friends')" />
    </template>
  </sidebar-layout>
</template>

<script>
import ChangeToAttending from './change-to-attending'
import { mapGetters, mapState } from 'vuex'
import NotAttendingButton from './not-attending-button'
import RsvpedShifts from './rsvped-shifts'
import SharingPrompt from '@/campaign-action-shared/sharing-prompt'
import StatusBanner from '@/campaign-action-shared/status-banner'
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'

export default {
  components: { ChangeToAttending, NotAttendingButton, RsvpedShifts, SharingPrompt, SidebarLayout, StatusBanner },

  computed: {
    ...mapState(['eventStatus']),
    ...mapGetters(['attending', 'eventCanBeShared', 'notAttending', 'onWaitlist', 'shiftedEvent']),

    attendingStatusText() {
      if (this.attending) {
        return this.i18n.t('events.show.attending_status_yes')
      } else if (this.notAttending) {
        return this.i18n.t('events.show.attending_status_no')
      } else if (this.onWaitlist) {
        return this.i18n.t('events.show.attending_status_waitlist')
      } else {
        throw 'unrecognized attending status'
      }
    },

    bannerStatus() {
      if (this.attending) {
        return 'success'
      } else {
        return 'default'
      }
    },

    iconClass() {
      if (this.attending) {
        return 'icon-ok'
      } else if (this.notAttending) {
        return 'icon-cancel'
      } else if (this.onWaitlist) {
        return 'icon-list'
      } else {
        throw 'unrecognized attending status'
      }
    }
  }
}
</script>
